import Includes from "./Includes";
import PlayBox from "./PlayBox";
import Thumbnail from "./Thumbnails";
import CheckOutWrapper from "./stripe/CheckOutWrapper";
import { Songcard } from "@/types";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Card,
  CardBody,
  Center,
  Heading,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { useInView } from "framer-motion";
import Link from "next/link";
import { useRef } from "react";

interface ItemProp {
  item: {
    id: number;
    card: Songcard;
  };
}

const CardOfTheDaySingle = ({ item }: ItemProp) => {
  const { colorMode } = useColorMode();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <div ref={ref}>
      <>
        <br />
        <Center
          style={{
            transform: isInView ? "none" : "translateY(+100px)",
            transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
        >
          <Card
            maxW="xs"
            align="center"
            bgColor={colorMode == "dark" ? "black" : "white"}
            variant="outline"
            borderColor={colorMode == "dark" ? "white" : "black"}
            borderStyle="dotted"
            borderRadius={15}
          >
            <CardBody>
              <Link href={`/cards/${item.card.uuid}`}>
                <Thumbnail
                  ext_file={item.card.ext_file}
                  comp_file={item.card.comp_file}
                  image={item.card.image}
                />
              </Link>
              <br />
              <PlayBox card={item.card} />
              <Accordion mt={5} allowMultiple>
                <Text ml={4} mb={3} mt={2}>
                  is a Songcard from
                  <br />
                  {item.card.primary_artist && (
                    <Text as="b" key={item.card.primary_artist.slug}>
                      <Link href={`/artists/${item.card.primary_artist.slug}`}>
                        {item.card.primary_artist.name}
                      </Link>
                    </Text>
                  )}
                </Text>
                <AccordionItem>
                  <Heading as="h2">
                    <AccordionButton>
                      <Box as="span" flex="1" textAlign="left">
                        Included items
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </Heading>
                  <AccordionPanel pb={4}>
                    <Includes cardFiles={[]} />
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
              <CheckOutWrapper
                id={item.card.id}
                art={""}
                uuid={item.card.uuid}
                issued={""}
                price={2.99}
                image={item.card.image}
                ext_file={item.card.song.ext_file}
              />
            </CardBody>
          </Card>
        </Center>
      </>
    </div>
  );
};

export default CardOfTheDaySingle;
